<template>
  <div v-if="!closed">
    <div class="blackBG"></div>
    <div class="onboarding">
      <div class="modal">
        <AudioPlayer v-if="audioSrc" :audioSrc="audioSrc" :autoPlay="true" />
        <div v-if="text" class="description">{{ text }}</div>
        <VideoPlayer1
          v-if="vidSrc"
          :vidSrc="makeLinkEmbaddable(vidSrc)"
          class="video-p"
        />
        <img v-if="imgSrc" id="img" :src="lessonImage" />
        <!-- <Spacer height="12" /> -->

        <button class="approve" @click="closePop">
          {{ $t("OnBoardingModal.OnBoardingModal.start") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import "./style.scss";
import AudioPlayer from "../Shared/AudioPlayer.vue";
import VideoPlayer from "../Shared/VideoPlayer.vue";
import AudioBtn1 from "../Shared/audioBtn.vue";
import VideoPlayer1 from "../Shared/VideoPlayer.vue";
import Spacer from "../Shared/Spacer.vue";
import { courseService } from "../../services/courseService";

export default {
  data() {
    return {
      closed: false,
      isAudio: 1,
      lessonImage: null
    };
  },
  props: {
    text: {
      type: String,
      default: ""
    },
    audioSrc: {
      type: String,
      default: ""
    },
    vidSrc: {
      type: String,
      default: ""
    },
    imgSrc: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "lesson"
    },
    id: {
      type: Number,
      default: 0
    }
  },
  watch: {
    audioSrc() {
      if (this.audioSrc) this.isAudio = 0;
    }
  },
  async mounted() {
    this.lessonImage = this.imgSrc;
    let lesson;
    if (this.type === "lesson") {
      lesson = await courseService.getLessonFromServer(this.id);
      if (lesson.game) this.lessonImage = lesson.game.intro_image;
    }
    if (this.type === "game") {
      lesson = await courseService.getGame(this.id);
      console.log(lesson);
      this.lessonImage = lesson.intro_image;
    }
    if (this.audioSrc) this.isAudio = 0;
  },
  methods: {
    closePop(e) {
      this.closed = true;
      this.$emit("clicked", this.id);
    },
    makeLinkEmbaddable: link => {
      if (String(link).includes("shorts")) {
        const youtubeID = String(link).split("/shorts/")[1];
        return (
          "https://www.youtube.com/embed/" +
          youtubeID +
          "?autoplay=" +
          this.isAudio +
          "&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0"
        );
      }
      if (String(link).includes(".be/")) {
        const youtubeID = String(link).split(".be/")[1];
        return (
          "https://www.youtube.com/embed/" +
          youtubeID +
          "?autoplay=" +
          this.isAudio +
          "&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0"
        );
      }
      const youtubeID = String(link).split("watch?v=")[1];
      return (
        "https://www.youtube.com/embed/" +
        youtubeID +
        "?autoplay=" +
        this.isAudio +
        "&fs=1&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0"
      );
    }
  },

  components: { AudioPlayer, VideoPlayer, AudioBtn1, VideoPlayer1, Spacer }
};
</script>

<style scoped>
.modal {
  padding: 0;
  padding-top: 15px;
  position: absolute;
}

.video-p {
  width: 100%;
  height: 250px;
}

.approve {
  background: var(--button-primary);
  color: var(--button-primary-text);
  padding: 4px;
  border-radius: 8px;
  min-height: 60px;
  width: 100%;
  font: var(--medium-font);
}
</style>



// WEBPACK FOOTER //
// OnBoardingModal.vue?41dce488